import { getApiClient } from './apiClient';
const apiBase = 'credentials/consumers/v2';
export const getAcademyCertifications = () => getApiClient().get(`${apiBase}/credential-definitions?type=CERTIFICATION`);